import Fuse from "fuse.js";
import Handlebars from "handlebars";

// Wrap everything in a DOMContentLoaded listener to ensure libraries are loaded
document.addEventListener("DOMContentLoaded", () => {
	// Change Handlebars delimiters to avoid Go template collision

	const templateSrc = `
    <li><a href="{{url}}" class="result-link">
        <span class="result-artist">{{artist}}</span>
        <span class="result-divider"> — </span>
        <span class="result-title">{{title}} ({{book_title}})</span>
        </a>
    </li>
    `;
	const renderTemplate = Handlebars.compile(templateSrc);

	// DOM Elements
	const searchInput = document.getElementById(
		"book-search",
	) as HTMLInputElement;
	const resultsContainer = document.getElementById("search-results");
	const luckyButton = document.getElementById(
		"lucky-button",
	) as HTMLButtonElement | null;

	interface SearchIndexEntry {
		artist: string;
		title: string;
		url: string;
		book_title: string;
	}

	let fuseInstance: Fuse<SearchIndexEntry> | null = null;
	let booksData: SearchIndexEntry[] = [];

	// Fetch data and initialize Fuse.js on startup
	async function initSearch() {
		try {
			const response = await fetch("/sheets.json");
			if (!response.ok) throw new Error("Network response was not ok");

			booksData = (await response.json()) as SearchIndexEntry[];

			const options = {
				keys: ["artist", "title"],
				threshold: 0.3,
			};

			// This will now reliably find the 'Fuse' global variable
			fuseInstance = new Fuse(booksData, options);

			searchInput.disabled = false;
			searchInput.placeholder = "Search books...";
		} catch (error) {
			console.error("Failed to initialize search index:", error);
			searchInput.placeholder = "Failed to load search index.";
		}
	}

	// Render results to the DOM
	function displayResults(results: { item: SearchIndexEntry }[]) {
		if (results.length === 0) {
			if (searchInput.value.trim() !== "") {
				resultsContainer!.innerHTML = "<li>No results found</li>";
			} else {
				resultsContainer!.innerHTML = "";
			}
			return;
		}

		const html = results.map((result) => renderTemplate(result.item)).join("");
		resultsContainer!.innerHTML = html;
	}

	// Debounce helper function
	function debounce(func: (this: any, ...args: any[]) => void, delay: number) {
		let timeoutId: ReturnType<typeof setTimeout>;
		return function (this: any, ...args: any[]) {
			clearTimeout(timeoutId);
			timeoutId = setTimeout(() => {
				func.apply(this, args);
			}, delay);
		};
	}

	// Handle the actual input event
	const handleSearch = debounce((event: Event) => {
		const query = (event.target as HTMLInputElement).value.trim();

		if (!query) {
			resultsContainer!.innerHTML = "";
			return;
		}

		if (fuseInstance) {
			const searchResults = fuseInstance.search(query);
			displayResults(searchResults);
		}
	}, 250);

	searchInput.addEventListener("input", handleSearch);
	searchInput.addEventListener("input", (event) => {
		const query = (event.target as HTMLInputElement).value.trim();
		const container = document.getElementById("home-container");
		if (container) {
			if (query) {
				container.classList.add("has-query");
			} else {
				container.classList.remove("has-query");
			}
		}
	});

	// "I'm feelin' lucky" — pick a random song and navigate to it
	if (luckyButton) {
		luckyButton.addEventListener("click", () => {
			if (!booksData.length) return;
			const randomIndex = Math.floor(Math.random() * booksData.length);
			const randomBook = booksData[randomIndex];
			// Only navigate to internal sheet URLs
			if (randomBook.url && randomBook.url.startsWith("/sheets/")) {
				window.location.href = randomBook.url;
			}
		});
	}

	// Start the engine safely
	initSearch();
});
